import * as React from 'react';

import invariant from 'invariant';
import PropTypes from 'prop-types';

// @ts-ignore
import CurrentUser from 'auth/CurrentUser';
import LoadingModal from 'components/LoadingModal';
import QuickPromotionModal from 'components/QuickPromotionModal';
// @ts-ignore
import { ButtonActionTypes, ResponseTypes, TriggerTypes } from 'constants/QuickPromotionConstants';
import QuickPromotion from 'entities/QuickPromotion';
import * as FluxStore from 'flux/lib/FluxStore';
import { Container } from 'flux/utils';
import { mountModal } from 'lib/modal';
// @ts-ignore
import { handleResponse } from 'lib/QuickPromotionActionHandler';

type State = {
  promotions: Array<QuickPromotion>;
};

class QuickPromotionAppOpenedModals extends React.Component<{}, State> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  static getStores() {
    // doing as cast here as we are using the flux store more generically and the types aren't happy.
    return ([CurrentUser] as any) as FluxStore<any>[];
  }

  static calculateState(state: State) {
    return {
      promotions: CurrentUser.getQuickPromotionsForTrigger(TriggerTypes.APP_OPENED),
    };
  }

  componentDidMount() {
    this.checkForPrompts();
  }

  componentDidUpdate() {
    this.checkForPrompts();
  }

  shown = false;

  handleConfirm = (promotion: QuickPromotion, data?: any) => {
    if (
      promotion.getPrimaryAction().getActionType() === ButtonActionTypes.LINK ||
      promotion.getPrimaryAction().getActionType() === ButtonActionTypes.DEEPLINK
    ) {
      mountModal(<LoadingModal />, this);
    }
    handleResponse(this.context.router, promotion, ResponseTypes.PRIMARY_ACTION, data);
  };

  handleCancel = (promotion: QuickPromotion) => {
    const secondaryAction = promotion.getSecondaryAction();
    invariant(secondaryAction, 'Cannot call cancel without a secondary action');
    if (
      secondaryAction.getActionType() === ButtonActionTypes.LINK ||
      secondaryAction.getActionType() === ButtonActionTypes.DEEPLINK
    ) {
      mountModal(<LoadingModal />, this);
    }
    handleResponse(this.context.router, promotion, ResponseTypes.SECONDARY_ACTION);
  };

  checkForPrompts() {
    const { promotions } = this.state;

    if (!this.shown) {
      const promotion = promotions.find(p => p.isShowable());
      if (promotion) {
        this.shown = true;

        mountModal(
          <QuickPromotionModal
            onConfirm={this.handleConfirm}
            onCancel={this.handleCancel}
            promotion={promotion}
            triggeredContext={'quick_promotion:' + promotion.getPromotion()}
            onRequestHide={() => {}}
          />,
          this
        );
      }
    }
  }

  render() {
    return null;
  }
}

export default Container.create(QuickPromotionAppOpenedModals, { pure: false });
